<template>
  <div>
    <CurvedBottomNavigation 
      :options="options" 
      v-model="selected" 
      @callbackSearchAction="searchAreaToggle"
      @callbackMenuAction="menuToggle"
      @callbackSwpAction="swpToggle"
      @callbackAction="callbackAction" />
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>

import selectConfig from '@/js/selectConfig';
export default {
  name: "Footer",
  computed: {
    changeSearchAreaShow() {
      return this.$store.state.app.searchAreaToggle;
    },
    isMain() {
      return this.$route.name === 'main' || this.$route.path === '/'
    },
    isMenuTitle() {
      let data = this.$_.find(this.$store.getters.addRouters, { name: this.$route.name });
      return data ? true : false;
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    changeSearchAreaShow() {
      this.searchAreaShow = this.$_.clone(this.changeSearchAreaShow)
    },
    $route(to, from) {
      if (to.path != from.path) {
        this.getApprCnt();
      }
    }
  },
  data() {
    return {
      searchAreaShow: false,
      apprCnt: null,
      selected: 1,
      options: [],
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  methods: {
    init() {
      this.getApprCnt();
    },
    searchAreaToggle() {
      this.searchAreaShow = true;
      this.$store.dispatch('searchAreaToggle', this.searchAreaShow);
    },
    menuToggle() {
      const el = document.body;
      let className = 'closed-sidebar-open'
      if (el.classList.contains(className)) {
        el.classList.remove(className);
      } else {
        el.classList.add(className);

        let _leftMenu = document.getElementsByClassName('left-sidebar-menu')
        if (_leftMenu && _leftMenu[0]) {
          _leftMenu[0].focus();
        }
      }
    },
    swpToggle(row) {
      this.popupOptions.title = '작업허가서';
      this.popupOptions.param = {
        sopWorkPermitId: row ? row.sopWorkPermitId : '',
        permitTypeCd: row ? row.permitTypeCd : '',
      };
      this.popupOptions.target = () => import(`${"@/pages/sop/swp/safeWorkPermitDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    // _type
    callbackAction(_type) {
       // 부적합/개선 / 안전순찰(점검) / 위험성평가 / TBM / 산업안전위원회
      if (_type == 'MENU000163') { // 안전보건팀 패트롤
        this.popupOptions.title = '안전보건팀 패트롤 상세'; // 안전순찰(점검) 상세
        this.popupOptions.param = {
          sopCtoId: ''
        };
        this.popupOptions.target = () => import(`${"@/pages/sop/cto/ctoDetail.vue"}`);
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closePopup;
      } else if (_type == 'MENU000068') { // 개선
        this.popupOptions.title = '개선 상세'; // 부적합/개선 상세
        this.popupOptions.param = {
          sopImprovementId: '',
          ibmTaskTypeCd: 'ITT9999999',
        };
        this.popupOptions.target = () => import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closePopup;
      } else if (_type == 'MENU000220') { // 순회점검 
        this.popupOptions.title = '순회점검 상세'; // 순회점검 상세
        this.popupOptions.param = {
          saiPatrolId: '',
        };
        this.popupOptions.target = () => import(`${"@/pages/sai/patrol/patrolDetail.vue"}`);
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closePopup;
      } else if (_type == 'MENU000275') { // 환경 순회점검 상세 
        this.popupOptions.title = '환경 순회점검 상세'; // 환경 순회점검 상세
        this.popupOptions.param = {
          envPatrolId: '',
        };
        this.popupOptions.target = () => import(`${"@/pages/env/ptr/envPatrolDetail.vue"}`);
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closePopup;
      } else if (_type == 'MENU000299') { // 근로자 안전보건 제안
        this.popupOptions.title = '안전 의견 게시판 상세'; // 안전 의견 게시판 상세
        this.popupOptions.param = {
          boardId: '',
        };
        this.popupOptions.target = () => import(`${"@/pages/sai/sob/safOpinionBoardDetail.vue"}`);
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closePopup;
      } 
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.$emit('closePopup')
    },
    getApprCnt() {
      this.$http.url = selectConfig.sys.appr.list.mycnt.url;
      this.$http.type = 'GET';
      this.$http.param = {
        approvalUserId: this.$store.getters.user.userId
      };
      this.$http.request((_result) => {
        if (_result.data.apprCnt1 + _result.data.apprCnt2 + _result.data.apprCnt3 + _result.data.apprCnt4 > 0) {
          this.apprCnt = _result.data.apprCnt1 + _result.data.apprCnt2 + _result.data.apprCnt3 + _result.data.apprCnt4;
        }

        if (this.isMain) {
          this.options = [
            {
              id: 1,
              icon: "home",
              title: "HOME",
              path: "/",
            },
            { 
              id: 7, 
              icon: "menu", 
              title: "MENU",
                types: 'MENU',
            },
          ]
          this.selected = 1;
        } else if (!this.isMain && this.isMenuTitle) {
          if (this.$route.name == 'MENU000999') {
            this.options = [
              {
                id: 1,
                icon: "home",
                title: "HOME",
                path: "/",
              },
              { 
                id: 2, 
                icon: "notifications", 
                title: "알림",
                path: "/sys/appr/doc/apprTodo",
                badge: this.apprCnt,
              },
              { 
                id: 7, 
                icon: "menu", 
                title: "MENU",
                types: 'MENU',
              },
            ]
          } else {
            let _child = [];
            let _types = null;
            let _icons = 'add';
            if (this.$route.name == 'MENU000045') { // 작업허가서
              _child = [
                { id: 101, types: 'SWP1', icon: "handyman", title: "일반", color: 'bg-amber-7' },
                { id: 102, types: 'SWP2', icon: "handyman", title: "밀폐", color: 'bg-red-6' }
              ];
            } else if (this.$route.name == 'MENU000163' 
            || this.$route.name == 'MENU000220'
            || this.$route.name == 'MENU000275'
            || this.$route.name == 'MENU000068'
            || this.$route.name == 'MENU000299') { // 안전보건팀 패트롤 / 안전환경 점검반 / 환경팀 패트롤 / 개선관리
              _types = this.$route.name;
            } else {
              _icons = 'do_not_disturb_alt'
            }
            this.options = [
              {
                id: 1,
                icon: "home",
                title: "HOME",
                path: "/",
              },
              { 
                id: 2, 
                icon: "notifications", 
                title: "알림",
                path: "/sys/appr/doc/apprTodo",
                badge: this.apprCnt,
              },
              {
                id: 3,
                icon: _icons,
                title: "",
                childs: _child,
                types: _types,
              },
              { 
                id: 7, 
                icon: "menu", 
                title: "MENU",
                types: 'MENU',
              },
              { 
                id: 5, 
                icon: "search", 
                title: "검색조건",
                types: 'SERACH',
              },
            ]
          }
          if (this.$route.name != 'MENU000156' && this.$route.name != 'MENU000999') {
            this.selected = 3;
          }
        }
      },);
    },
  }
}
</script>